import { render, staticRenderFns } from "./AwardIndex.vue?vue&type=template&id=2ffef022&scoped=true"
import script from "./AwardIndex.vue?vue&type=script&lang=js"
export * from "./AwardIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffef022",
  null
  
)

export default component.exports